import { Badge } from "@capacit-com/lara-law-shared-ui";
import { Label } from "@capacit-com/lara-law-shared-ui";
import {
  getRoleBadgeVariant,
  getUserRoleLabel,
} from "../utils/workspaceRoleDisplay";
import { formatDate } from "@/lib/utils";
import UserAvatar from "@/components/images/UserAvatar";
import { useWorkspaceContext } from "../providers/WorkspaceContext";

type Props = {
  callToAction: React.ReactNode;
};

const WorkspaceHeader: React.FC<Props> = ({ callToAction }) => {
  const {
    workspace,
    isUserOwner,
    workspaceOwner,
    effectiveRole,
    isOrphanedInspection,
  } = useWorkspaceContext();

  return (
    <div className="flex items-end">
      <div className="flex flex-col gap-4 w-full">
        {isOrphanedInspection && (
          <div>
            <p className="font-medium">Forældreløst workspace</p>
            {workspace?.createdAt && (
              <p className="text-muted-foreground text-xs">
                Oprettet {formatDate(workspace.createdAt)}
              </p>
            )}
          </div>
        )}
        {workspaceOwner && !isOrphanedInspection && (
          <div className="flex items-center gap-4">
            <UserAvatar user={workspaceOwner} avatarClassName="size-8" />
            <div>
              <p>
                {workspaceOwner.firstName} {workspaceOwner.lastName}'s Workspace
              </p>
              {workspace?.createdAt && (
                <p className="text-muted-foreground text-xs">
                  Oprettet {formatDate(workspace.createdAt)}
                </p>
              )}
            </div>
          </div>
        )}
        <p>{workspace?.description}</p>
        {/* User's Access Level */}
        {workspace && effectiveRole && (
          <div className="flex text-xs items-center gap-2">
            <Label>Dit adgangs niveau: </Label>
            <Badge
              variant={getRoleBadgeVariant(effectiveRole)}
              className="select-none"
            >
              {getUserRoleLabel(effectiveRole)}
            </Badge>
            <p>
              {isUserOwner &&
                workspace.isParentWorkspace &&
                "Ejer på en anden org"}
            </p>
          </div>
        )}
      </div>

      <div className="ml-auto flex items-center gap-2 self-start">
        {callToAction}
      </div>
    </div>
  );
};

export default WorkspaceHeader;
